import { type ReactNode, useEffect, useState } from 'react'

import { type Theme, ThemeContext } from '@/shared/hooks/use-theme'

const getSystemTheme = (): Theme => {
    if (globalThis.window === undefined) {
        return 'light'
    }

    return globalThis.matchMedia?.('(prefers-color-scheme: dark)')?.matches ? 'dark' : 'light'
}

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const [theme, setTheme] = useState<Theme>(getSystemTheme)

    useEffect(() => {
        if (globalThis.window === undefined) {
            return
        }

        const mql = globalThis.matchMedia?.('(prefers-color-scheme: dark)')

        if (!mql) {
            return
        }

        const handler = (event: MediaQueryListEvent): void => {
            setTheme(event.matches ? 'dark' : 'light')
        }

        mql.addEventListener?.('change', handler)

        return () => {
            mql.removeEventListener?.('change', handler)
        }
    }, [])

    return <ThemeContext value={{ theme }}>{children}</ThemeContext>
}
